import { useInfiniteQuery, useQuery } from "../_app/lib/query";
import { Query } from "../filter/types";
import { AjaxResponse } from "../_app/api";
import { getServiceAnalysis, getServiceAnalysisColumns } from "./api";
import { ServiceAnalysisResponse } from "./types";
import { SortParam } from "../_app/components/Table/helpers";
import { useContextProvider } from "../context/providers/ContextProvider";

export function useGetServiceAnalysisColumns(options = {}) {
  const { contextId: accountId } = useContextProvider();
  return useQuery({
    queryKey: ["serviceAnalysisColumns", accountId],
    queryFn: () => getServiceAnalysisColumns(accountId),
    ...options,
  });
}

export function useGetServiceAnalysis(limit: number, sort: SortParam[], queries: Query[], columns: string[], options = {}) {
  const { contextId: accountId } = useContextProvider();
  return useInfiniteQuery<ServiceAnalysisResponse, AjaxResponse>({
    queryKey: ["serviceAnalysis", { accountId, limit, sort, queries, columns }],
    queryFn: ({ pageParam }) => getServiceAnalysis(accountId, pageParam as string, limit, sort, queries, columns),
    initialPageParam: undefined,
    getNextPageParam: (lastPage: any) => {
      return lastPage?.nextPageToken || undefined;
    },
    ...options,
  });
}
